import { styled } from "@vitality-ds/system";
import baseButtonStyles from "./styles/BaseButton.styles";
import baseContentContainerStyles from "./styles/BaseContentContainer.styles";
import baseLoadingContainerStyles from "./styles/BaseLoadingContainer.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseButton = styled("button", baseButtonStyles);
export var BaseContentContainer = styled("span", baseContentContainerStyles);
export var BaseLoadingContainer = styled("span", baseLoadingContainerStyles);